/** Temporarily own the title only while the document is hidden. */
export function installIdleTabTitle(message: string, delayMs: number): () => void {
  let originalTitle = document.title;
  let idle = false;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const cancelTimer = () => {
    clearTimeout(timer);
    timer = undefined;
  };
  const restore = () => {
    cancelTimer();
    if (idle && document.title === message) document.title = originalTitle;
    idle = false;
  };
  const syncVisibility = () => {
    cancelTimer();
    if (document.visibilityState !== "hidden") {
      restore();
      return;
    }
    if (idle) return;
    timer = setTimeout(() => {
      if (document.visibilityState !== "hidden") return;
      originalTitle = document.title;
      idle = true;
      document.title = message;
    }, delayMs);
  };

  // Next can stream or replace metadata after navigation, even in a hidden tab.
  // Preserve the latest real title and keep our temporary title until return.
  const observer = new MutationObserver(() => {
    if (document.title === message) return;
    originalTitle = document.title;
    if (idle) document.title = message;
  });
  observer.observe(document.head, { subtree: true, childList: true, characterData: true });
  document.addEventListener("visibilitychange", syncVisibility);
  window.addEventListener("pagehide", restore);
  window.addEventListener("pageshow", syncVisibility);
  syncVisibility();

  return () => {
    observer.disconnect();
    document.removeEventListener("visibilitychange", syncVisibility);
    window.removeEventListener("pagehide", restore);
    window.removeEventListener("pageshow", syncVisibility);
    restore();
  };
}
